import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { NbDialogService } from '@nebular/theme';
import { MiscellaneousComponent } from './pages/miscellaneous/miscellaneous.component';
@Injectable({
  providedIn: 'root',
})
export class RestService {
  // http://localhost:8080/
  // https://api.landydev.com/
  // https://api.axylerate.com/v1/
  baseUrl: string;
  token: string;
  tokens: string;
  urlSearchUnderwriter: any;
  urlSearchProducer: any;
  urlSearchAccounts: any;
  urlSearchJournalEntry: any;
  urlSearchReoccuringJournal: any;
  urlSearchAccountsTab: any;
  loginEmployeeId: number = parseInt(localStorage.getItem('employeeId'));
  employeeAbbreviation: string = (localStorage.getItem('employeeAbbreviation'));
  // uiBaseUrl: any = 'http://localhost:4200/#/';
  //  uiBaseUrl: any = 'https://www.landydev.com/#/';
  // uiBaseUrl: any = 'https://v2.landydev.com/#/';
   uiBaseUrl: any = 'https://qa.landydev.com/api/qa/';

  constructor(private http: HttpClient, private dialogService: NbDialogService) {
    //  this.baseUrl = 'https://www.landydev.com/api/v1/';
    // this.baseUrl = 'https://v2.landydev.com/api/v2/';
    // this.baseUrl = 'http://localhost:8080/';
    this.baseUrl = 'https://qa.landydev.com/api/qa/';
  }
  private extractData(res: Response) {
    const body = res;
    return body || {};
  }
  encodeObj(string) {
    return encodeURIComponent(JSON.stringify(string));
  }
  decodeURLParams(urlParams) {
    return JSON.parse(decodeURIComponent(urlParams));
  }
  validateString(str) {
    return (str !== undefined && str != null && !(/^\s*$/.test(str)));
  }
  replacePreviousURL(url, params) {
    window.history.pushState({ prevUrl: window.location.href }, null, this.uiBaseUrl + url + params);
  }
  getToken() {
    return localStorage.getItem('token');
  }
  model(id): Observable<any> {
    let roleName: any = localStorage.getItem('roleId') ? localStorage.getItem('roleId') : '';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'Authorization':this.dummyToken,
        'X-Role': roleName,
      }),
    };
    return this.http.get(this.baseUrl + id, httpOptions,
    ).pipe(map(this.extractData));
  }
  postModel(model, id): Observable<any> {
    let roleName: any = localStorage.getItem('roleId') ? localStorage.getItem('roleId') : '';
    return this.http.post<any>(this.baseUrl + id, JSON.stringify(model), {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'X-Role': roleName,
        // 'Authorization':this.dummyToken
      }),
    }).pipe(
      tap(_ => ''),
      catchError(this.handleError<any>('postModel')),
    );
  }
  postModelWithFile(model, id): Observable<any> {
    let roleName: any = localStorage.getItem('roleId') ? localStorage.getItem('roleId') : '';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Transfer-Encoding': 'utf-8',
        'X-Role': roleName,
        // 'Authorization':this.dummyToken
      }),
    };
    return this.http.post<any>(this.baseUrl + id, model, httpOptions).pipe(
      tap(_ => ''),
      catchError(this.handleError<any>('postModelWithFile')),
    );
  }
  updateModel(model, id): Observable<any> {
    let roleName: any = localStorage.getItem('roleId') ? localStorage.getItem('roleId') : '';
    return this.http.put(this.baseUrl + id, JSON.stringify(model),
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'X-Role': roleName,
          // 'Authorization':this.dummyToken
        }),
      }).pipe(
        tap(_ => ''),
        catchError(this.handleError<any>('updateModel')),
      );
  }
  deleteModel(id): Observable<any> {
    let roleName: any = localStorage.getItem('roleId') ? localStorage.getItem('roleId') : '';
    return this.http.delete<any>(this.baseUrl + id, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'X-Role': roleName,
        // 'Authorization':this.dummyToken
      }),
    }).pipe(
      tap(_ => ''),
      catchError(this.handleError<any>('deleteModel')),
    );
  }

  deleteModelByObject(model,id): Observable<any> {
    let roleName: any = localStorage.getItem('roleId') ? localStorage.getItem('roleId') : '';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Role': roleName || '',
      // Uncomment the line below to add Authorization if needed
      // 'Authorization': this.dummyToken,
    });
    return this.http.delete<any>(this.baseUrl + id,
    {
      body:model,
      headers,
    }).pipe(
      tap(_ => ''),
      catchError(this.handleError<any>('deleteModelByObject')),
    );
  }
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      // console.error(error); // log to console instead
      // TODO: better job of transforming error for user consumption
      // Let the app keep running by returning an empty result.
      if (error) {
        this.dialogService.open(MiscellaneousComponent, {
          context: {
            title: 'Error Occurred',
            message: `An error occurred during ${operation}: ${error.message || error.error.message}`,
            errorMessage: error.error.message,
          },
        });
      }


      return of(result as T);
    };
  }

  postModelResponseAsBlob(model): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');

    return this.http.post(
      'https://pdfmake.landydev.com/pdf',
      model,
      {
        responseType: 'blob'
      }
    ).pipe(catchError(this.handleError<any>('postModel')));
  }
}
// this.router.navigate(['pages/viewPolicy/' + riskId]);
// const sign = require('jwt-encode');
// const secret = 'secret';
// const jwt = sign(search, secret);
// this.restService.urlSearchUnderwriter = jwt;
// this.route.params.subscribe(res => {
//
//   if (Object.keys(res).length > 0) {
//     this.search = jwt_decode(res.searchEncodedString);
//   }
// },
// );
